
import Vue, { PropType } from "vue";
import { SignalecticData } from "@/@modules/fseg/services/interfaces/worker/SignaleticData";

export default Vue.extend({
  props: {
    index: {
      required: true,
      type: Number,
    },
    signaleticData: {
      required: true,
      type: Object as PropType<SignalecticData>,
    },
  },
});
